import redux, { createStore } from 'redux';
import { getAllAffirmations, getAllCategories } from '../api/api';
import { AffirmationWithCategory } from '../interfaces/tell_me/affirmationWithCategory.types';
import { Category } from '../interfaces/tell_me/category.types';
import { ReelWithCategory } from '../interfaces/tell_me_watch/reel.types';
import { ReelsCategory } from '../interfaces/tell_me_watch/reelsCategory.types';
import reducer from './reducer/reducer';


export interface AppState {
    categories: Category[],
    affirmations: AffirmationWithCategory[],
    reels: ReelWithCategory[],
    reelsCategories: ReelsCategory[],
}
export const INITIAL_STATE: AppState = {
    affirmations: [],
    categories: [],
    reels: [],
    reelsCategories: [],
}

const store = createStore(reducer);

export {
    store
};